import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {DateAdapter, MAT_DATE_LOCALE, MatNativeDateModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule} from '@angular/material/form-field';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTableModule} from '@angular/material/table';
import {MAT_TABS_CONFIG, MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TimestampDateAdapter} from '../lib/timestamp-date-adapter';
import {Platform} from '@angular/cdk/platform';
import {MatAutocompleteModule} from '@angular/material/autocomplete';

@NgModule({
    declarations: [],
    imports: [MatStepperModule, MatButtonModule, MatCardModule, MatDividerModule, MatToolbarModule,
        MatIconModule, MatSidenavModule, MatListModule, MatExpansionModule, MatMenuModule,
        MatTableModule, MatSortModule, MatPaginatorModule, MatGridListModule, MatProgressBarModule,
        MatFormFieldModule, MatInputModule, MatDatepickerModule, MatNativeDateModule,
        MatCheckboxModule, MatSlideToggleModule, MatRadioModule, MatSelectModule,
        MatButtonToggleModule, MatTabsModule, MatDialogModule, MatSnackBarModule,
        MatTooltipModule, MatChipsModule, MatAutocompleteModule],
    exports: [
        MatStepperModule, MatButtonModule, MatCardModule, MatDividerModule, MatToolbarModule,
        MatIconModule, MatSidenavModule, MatListModule, MatExpansionModule, MatMenuModule,
        MatTableModule, MatSortModule, MatPaginatorModule, MatGridListModule, MatProgressBarModule,
        MatFormFieldModule, MatInputModule, MatDatepickerModule, MatNativeDateModule,
        MatCheckboxModule, MatSlideToggleModule, MatRadioModule, MatSelectModule,
        MatButtonToggleModule, MatTabsModule, MatDialogModule, MatSnackBarModule,
        MatChipsModule, MatTooltipModule, MatAutocompleteModule
    ],
    providers: [
        {provide: DateAdapter, useClass: TimestampDateAdapter, deps: [MAT_DATE_LOCALE, Platform]},
        {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'outline', floatLabel: 'always'}},
        {provide: MAT_TABS_CONFIG, useValue: {animationDuration: '0ms'}},
    ],
})
export class MaterialModule {
}
